import React from 'react';
import { motion } from 'framer-motion';
import { MATURITY_LEVELS } from '../utils/scoreCalculator';
import styles from './MaturityLadder.module.css';

export default function MaturityLadder({ currentLabel }) {
  const tiers = [...MATURITY_LEVELS].reverse();

  return (
    <ul className={styles.ladder}>
      {tiers.map((tier, i) => {
        const isActive = tier.label === currentLabel;
        return (
          <motion.li
            key={tier.label}
            className={`${styles.tier} ${isActive ? styles.tierActive : ''}`}
            initial={{ opacity: 0, x: -8 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 + i * 0.05, duration: 0.3 }}
          >
            <span
              className={styles.node}
              style={{ background: isActive ? tier.color : 'transparent', borderColor: tier.color }}
            />
            <span className={styles.tierLabel} style={isActive ? { color: tier.color } : undefined}>
              {tier.label}
            </span>
            {isActive && <span className={styles.youAreHere}>current</span>}
          </motion.li>
        );
      })}
    </ul>
  );
}
